/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var I;
!function (I) {
  I[I.INITIALIZING = 0] = "INITIALIZING", I[I.CONSTRUCTING = 1] = "CONSTRUCTING", I[I.CONSTRUCTED = 2] = "CONSTRUCTED";
}(I || (I = {}));
export { I as Lifecycle };